import EventSurvey from "../pages/EventSurvey";
import NotificationScreen from "../pages/NotificationScreen";
import PulseMotivational from "../pages/PulseMotivational";
import SpinTheWheel from "../pages/SpinTheWheel";
import {
  Home,
  Front,
  Privacy,
  Humans,
  Login,
  Loyalty,
  SpeedShopping,
  Capturenshare,
  Mashupnwin,
  YPYC,
  PulseNChill,
  Ayoba,
  Profile,
  Trivia,
  Referral,
  ViewAllEvents,
  ViewAllOffers,
  FastestFinger,
  JustBeSeries,
  BusinessChallenge,
  PeerTalk,
  BlackFriday,
  DigitalSkillsTraining,
  ErrorPage,
} from "../pages/index";

const routes = [
  {
    path: "/",
    exact: true,
    component: Front,
  },
  {
    path: "/login",
    exact: true,
    component: Login,
  },
  {
    path: "/error",
    exact: true,
    component: ErrorPage,
  },
  {
    path: "/home",
    // exact: true,
    component: Home,
  },
  {
    path: "/humans",
    exact: true,
    component: Humans,
    isPrivate: true,
  },
  {
    path: "/privacy",
    exact: true,
    component: Privacy,
  },
  {
    path: "/loyalty",
    component: Loyalty,
  },
  {
    path: "/offers",
    component: ViewAllOffers,
  },
  {
    path: "/events",
    component: ViewAllEvents,
  },
  {
    path: "/speedshopping",
    component: SpeedShopping,
  },
  {
    path: "/capturenshare",
    component: Capturenshare,
  },
  {
    path: "/mashupnwin",
    component: Mashupnwin,
  },
  {
    path: "/pulsenchill",
    component: PulseNChill,
  },
  {
    path: "/ypycregistration",
    component: YPYC,
  },
  {
    path: "/digital-skills-training",
    component: DigitalSkillsTraining,
  },
  {
    path: "/just-be-series",
    component: JustBeSeries,
  },
  {
    path: "/ayoba",
    component: Ayoba,
  },
  {
    path: "/black-friday",
    component: BlackFriday,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/trivia",
    component: Trivia,
  },
  {
    path: "/referral",
    component: Referral,
  },
  {
    path: "/pulse_motivational",
    component: PulseMotivational,
  },
  {
    path: "/fastest_finger",
    component: FastestFinger,
  },
  {
    path: "/business_challenge",
    component: BusinessChallenge,
  },
  {
    path: "/spin_the_wheel",
    component: SpinTheWheel,
  },
  {
    path: "/peer_talk",
    component: PeerTalk,
  },
  {
    path: "/event_survey",
    component: EventSurvey,
  },
  {
    path: "/notifications",
    component: NotificationScreen,
  },
];

export default routes;
